import Shuffle from 'shufflejs';

/**
 * A class to create and manage a Shuffle portfolio grid with filtering functionality.
 */
export default class ShufflePortfolio {
  /**
   * Creates an instance of the ShufflePortfolio class.
   * @param {HTMLElement} element - The container element for the shuffle grid.
   */
  constructor(element) {
    this.element = element;
    this.shuffle = new Shuffle(element, {
      itemSelector: '.js-shuffle-item',
      speed: 500,
    });

    this.addFilterButtons();
  }

  /**
   * Adds event listeners to filter buttons and sets up their click handling.
   */
  addFilterButtons() {
    const options = document.querySelector('.js-filter-options');
    if (!options) {
      return;
    }

    const filterButtons = Array.from(options.children);
    const onClick = this._handleFilterClick.bind(this);

    filterButtons.forEach((button) => {
      button.addEventListener('click', onClick, false);
    });
  }

  /**
   * Handles the click event on a filter button and applies or removes the filter.
   * @param {Event} evt - The click event object.
   */
  _handleFilterClick(evt) {
    const btn = evt.currentTarget.firstElementChild;
    const isActive = btn.classList.contains('active');
    const btnGroup = btn.getAttribute('data-group');

    this._removeActiveClassFromChildren(btn.parentNode.parentNode);

    let filterGroup;
    if (isActive) {
      btn.classList.remove('active');
      filterGroup = Shuffle.ALL_ITEMS;
    } else {
      btn.classList.add('active');
      filterGroup = btnGroup;
    }

    this.shuffle.filter(filterGroup);
  }

  /**
   * Removes the 'active' class from all children of the specified parent element.
   * @param {HTMLElement} parent - The parent element whose children will be processed.
   */
  _removeActiveClassFromChildren(parent) {
    const { children } = parent;
    for (let i = children.length - 1; i >= 0; i--) {
      children[i].firstElementChild.classList.remove('active');
    }
  }
}

/**
 * Initializes the ShufflePortfolio instance if the relevant element exists.
 */
(function () {
  const portfolioElement = document.querySelector('.js-shuffle');
  if (portfolioElement === null) {
    return;
  }

  new ShufflePortfolio(portfolioElement);
})();
